module.exports = __webpack_public_path__ + "static/media/mail-bulk.136a766f.svg";